/* import { Sidebar } from "./Sidebar"; */

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      {/* <Sidebar /> */}
      <main className="ml-64 min-h-screen p-8">
        {children}
      </main>
    </div>
  );
}
